export default __webpack_public_path__ + "static/media/06.df32d4a0.jpg";